import { UserCUDto } from '../dtos/internal-user.dto';
import { RoleDto } from '../dtos/role.dto';

export class InternalUserModel {
    private data: UserCUDto;

    public constructor(data: UserCUDto) {
        this.data = data;
    }

    public getData(): UserCUDto {
        return { ...this.data };
    }

    public get usersId(): number {
        return this.data.usersId;
    }

    public set usersId(value: number) {
        this.data.usersId = value;
    }

    public get email(): string {
        return this.data.email;
    }

    public set email(value: string) {
        this.data.email = value;
    }

    public get userRegisterType(): string {
        return this.data.userRegisterType;
    }

    public set userRegisterType(value: string) {
        this.data.userRegisterType = value;
    }

    public get userProfileType(): string {
        return this.data.userProfileType;
    }

    public set userProfileType(value: string) {
        this.data.userProfileType = value;
    }

    public get userType(): string {
        return this.data.userType;
    }

    public set userType(value: string) {
        this.data.userType = value;
    }

    public get organizationId(): number {
        return this.data.organizationId;
    }

    public set organizationId(value: number) {
        this.data.organizationId = value;
    }

    public getFullName(): string {
        const firstName = this.firstName ?? '';
        const lastName = this.lastName ?? '';
        return firstName + ' ' + lastName;
    }

    public get firstName(): string {
        return this.data.firstName;
    }

    public set firstName(value: string) {
        this.data.firstName = value;
    }

    public get lastName(): string {
        return this.data.lastName;
    }

    public set lastName(value: string) {
        this.data.lastName = value;
    }

    public get middleName(): string {
        return this.data.middleName;
    }

    public set middleName(value: string) {
        this.data.middleName = value;
    }

    public get title(): string {
        return this.data.title;
    }

    public set title(value: string) {
        this.data.title = value;
    }

    public get phone(): string {
        return this.data.phone;
    }

    public set phone(value: string) {
        this.data.phone = value;
    }

    public get phoneType(): string {
        return this.data.phoneType;
    }

    public set phoneType(value: string) {
        this.data.phoneType = value;
    }

    public get address1(): string {
        return this.data.address1;
    }

    public set address1(value: string) {
        this.data.address1 = value;
    }

    public get address2(): string {
        return this.data.address2;
    }

    public set address2(value: string) {
        this.data.address2 = value;
    }

    public get address3(): string {
        return this.data.address3;
    }

    public set address3(value: string) {
        this.data.address3 = value;
    }

    public get city(): string {
        return this.data.city;
    }

    public set city(value: string) {
        this.data.city = value;
    }

    public get state(): string {
        return this.data.state;
    }

    public set state(value: string) {
        this.data.state = value;
    }

    public get country(): string {
        return this.data.country;
    }

    public set country(value: string) {
        this.data.country = value;
    }

    public get zipcode(): string {
        return this.data.zipcode;
    }

    public set zipcode(value: string) {
        this.data.zipcode = value;
    }

    public get mobilePhone(): string {
        return this.data.mobilePhone;
    }

    public set mobilePhone(value: string) {
        this.data.mobilePhone = value;
    }

    public get mobilePhoneCountry(): string {
        return this.data.mobilePhoneCountry;
    }

    public set mobilePhoneCountry(value: string) {
        this.data.mobilePhoneCountry = value;
    }

    public get status(): boolean {
        return this.data.status === 1;
    }

    public set status(value: boolean) {
        this.data.status = value ? 1 : 0;
    }

    public get roleName(): string {
        return this.data.roleName;
    }

    public set roleName(value: string) {
        this.data.roleName = value;
    }

    public get roles(): RoleDto[] {
        return this.data.roles;
    }
}
